module.exports = __webpack_public_path__ + "static/logo-bcorp-56e844364f9efcbb179d17174098a2ef.png";